import axios from 'axios';

const API_IMAGE = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:7071';

export const uploadImage = async (file, onProgress, options = {}) => {
  const formData = new FormData();
  formData.append('image', file);
  if (options.propertyId) {
    formData.append('propertyId', options.propertyId);
  }

  const res = await axios.post(`${API_IMAGE}/api/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress: (event) => {
      const percent = Math.round((event.loaded / event.total) * 100);
      if (onProgress) onProgress(percent);
    }
  });

  console.log('[🧪 Upload Response]', res.data);
  return res.data.imageUrl || res.data.url || res.data.secure_url;
};

export const deleteImage = async (publicId) => {
  try {
    console.log('[🌐 Delete Image]', publicId);
    const res = await axios.delete(`${API_IMAGE}/api/image`, {
      params: { public_id: publicId }
    });
    console.log('[✅ Cloudinary delete response]', res.data);
    return res.data;
  } catch (error) {
    console.error('[❌ deleteImage] Failed:', error);
    throw error;
  }
};
